<template>
  <svg :width="size" :height="size" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0031 18C8.32687 18 8.31977 16.3281 8.31977 13.4996C8.31977 10.671 2.5 8.68932 2.5 5.58401C2.5 2.96087 4.82524 3.00003 9.99956 3.00003C15.1748 3.00003 17.5 2.96087 17.5 5.58401C17.5 8.68932 11.6811 10.671 11.6811 13.4996C11.6811 16.3281 11.6785 18 10.0031 18Z"
      :stroke="color"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'AlertIcon',
  props: {
    size: {
      type: String,
      default: '20'
    },
    color: {
      type: String,
      default: '#3185FC'
    }
  }
}
</script>
